import { render, staticRenderFns } from "./groupManage.vue?vue&type=template&id=33518a18"
import script from "./groupManage.vue?vue&type=script&lang=ts"
export * from "./groupManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports